import React from "react";
import "./Title.css";

const Title = ({ titleText }) => {
  return <p className="Title">{titleText}</p>;
};

export default Title;
